import { CreateLeadRequest, UpdateLeadRequest, LeadResponse, CreateLeadError } from '@menesko/models-digesti';
import { useMutation, UseMutationOptions } from 'react-query';

import { FunnelApiClient } from '~/api';
import { config } from '~/config';

import { useAppLead } from './useAppLead';
import { useTracking } from './useTracking';

type Request = CreateLeadRequest | UpdateLeadRequest;

export const useLeadMutation = (options?: UseMutationOptions<LeadResponse, CreateLeadError, Request>) => {
  const { id, updateUser } = useAppLead();
  const tracking = useTracking();

  return useMutation(
    (data: Request) => {
      return FunnelApiClient<Request, LeadResponse>({ method: id ? 'PATCH' : 'POST', url: '/lead', data });
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        const { id, email } = data;

        if (!variables.id) {
          tracking.emailLeft({ leadId: id, email: variables.email });
        }

        updateUser({ id, email, webAppUrl: `${config.webAppUrl}?leadCode=${id}` });

        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    },
  );
};
